
















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Account } from '@/modules/admin/me';
import { UserTypes } from '@/enums/userTypes';

@Component
export default class Menu extends Vue {
  private UserTypes = UserTypes;

  @Prop({ default: false }) private isCollapse: boolean;

  private copyRight = process.env.VUE_APP_COPY_RIGHT;
  private defaultActive = '2';

  get user(): Account {
    return this.$store.state.adminMe.user;
  }

  get userName(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName}　${this.user.firstName}`;
    }
  }

  get myPageTitle(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName} ${this.user.firstName} さんの情報`;
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get userRole(): UserTypes {
    return this.$store.getters['adminAuth/userType'];
  }

  @Watch('userRole')
  private changeUserRole() {
    this.$nextTick(() => {
      this.setSelectRoute();
    });
  }

  @Watch('$route')
  private changeRoute() {
    this.setSelectRoute();
  }

  private mounted() {
    this.loadData();
  }

  private loadData() {
    this.setSelectRoute();
  }

  private setSelectRoute() {
    const name = this.$router.currentRoute.name;
    let selectName: string = '';
    if (!!name) {
      if (name.indexOf('AdminOwnerList') === 0) {
        selectName = 'AdminOwnerList';
        this.defaultActive = '1';
      }
      if (name.indexOf('AdminTop') === 0) {
        selectName = 'AdminTop';
        this.defaultActive = '2';
      }
      if (name.indexOf('AdminNewsList') === 0) {
        selectName = 'AdminNewsList';
        this.defaultActive = '3';
      }
      if (name.indexOf('AdminUserList') === 0) {
        selectName = 'AdminUserList';
        this.defaultActive = '4';
      }
    }
    const parent = this.$refs.menu as Vue;
    parent.$children.forEach((group) => {
      group.$children.forEach((li) => {
        if (!!li.$props.route && !!li.$props.route.name) {
          if (li.$props.route.name === selectName) {
            li.$el.classList.add('is-active');
          } else {
            li.$el.classList.remove('is-active');
            (li.$el as HTMLElement).blur();
          }
        }
      });
    });
  }

  private operate(command: any) {
    this.$router.push(command);
    this.$emit('selectMenu');
  }

  private onSelectMenu() {
    this.$emit('selectMenu');
  }
}
